import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import TopNavBar from '../components/top-nav-bar';

class TopNavBarContainer extends Component {
  render() {
    const { user, merchant, signinPage } = this.props;

    return (
      <TopNavBar
        user={user}
        merchant={merchant}
        signinPage={signinPage}
      />
    );
  }
}
const mapStateToProps = ({ purchases, users }) => {
  const purchase = purchases.byId[purchases.current];

  return {
    user: users.byId[users.current],
    merchant: get(purchase, 'merchant'),
  };
};

export default connect(mapStateToProps)(TopNavBarContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/top-nav-bar.container.js